import { Title } from "@mantine/core";

export const BaseTitle = Title